/**
 * The one way to draw a close / dismiss "X" (2026-09-10).
 *
 * Founder, on the Struggles sheet: "The X in the upper right needs some work.
 * It's too invisible." It was a 16px grey glyph at 70% opacity on a dark
 * sheet — and the same thin X was hand-rolled in ~36 places with ~36 styles.
 * iOS draws a close control as a small grey circle with a bold X; that is
 * what this is. Dialog and Sheet use it by default; inline cards use the
 * same class so every X in the app is the same X.
 */
import { X } from "lucide-react";
import { cn } from "@/lib/utils";

/** Layout classes (position, margin, shrink) are passed by the caller. */
export const closeButtonClass =
  "inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-muted text-foreground ring-1 ring-border/70 transition-[background-color,transform] duration-150 hover:bg-muted active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50";

export function CloseIcon({ className }: { className?: string }) {
  return <X className={cn("h-4 w-4", className)} strokeWidth={2.5} aria-hidden="true" />;
}
